import api from "./client";

export const getDictionaryItems = (id) =>
  api.get(`/api/dictionaries/${id}/items/`);

export const getDictionaries = () =>
  api.get(`/api/dictionaries/`);
